export let target = ""
export let isShowProdWarning = false
export let isShowVersionWarning = false

const getTarget = (origin: string) => {
  if (!origin) return ""

  if (origin.match(/localhost/)) {
    if (!window._env_?.LEKIMA_CONSOLE_API_ENDPOINT) return ""
    const matches = window._env_.LEKIMA_CONSOLE_API_ENDPOINT.match(/api-([A-Za-z]*)/)
    if (matches?.[1]) {
      return `LOCAL/${matches[1].toUpperCase()}`
    }
    if (window._env_.LEKIMA_CONSOLE_API_ENDPOINT.match(/api\./)) {
      return "LOCAL/PROD"
    }
    if (window._env_.LEKIMA_CONSOLE_API_ENDPOINT.match(/172/)) {
      return "LOCAL/GEORGE"
    }
    return "LOCAL/UNKNOWN"
  }

  if (origin.match(/trilee.site/)) {
    if (!window._env_?.RESOURCE_URL) return ""
    const matches = window._env_.RESOURCE_URL.match(/lekima-console-web-([a-zA-Z0-9-]+)/)
    if (matches?.[1]) {
      return matches[1].toUpperCase().replace("-", "")
    }
    return "UNKNOWN"
  }

  return ""
}

export const useEnvironment = () => {
  target = getTarget(origin)
  isShowProdWarning = ["PROD", "PROD2", "LOCAL/PROD", "LOCAL/PROD2", "LOCAL/GEORGE"].includes(
    target,
  )
  isShowVersionWarning = ["STG", "PROD", "PROD2"].includes(target)
  return { target, isShowProdWarning, isShowVersionWarning }
}
